/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';

/**
 * 
 * @export
 * @interface LeaderboardPrizeTierResponse
 */
export interface LeaderboardPrizeTierResponse {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardPrizeTierResponse
     */
    rankStart: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardPrizeTierResponse
     */
    rankEnd: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LeaderboardPrizeTierResponse
     */
    rewardConfigIds: Array<string>;
    /**
     * Catalog-item grants (reward-catalog Option B) — additive alongside rewardConfigIds during the migration.
     * @type {Array<RewardGrant>}
     * @memberof LeaderboardPrizeTierResponse
     */
    rewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardPrizeTierResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardPrizeTierResponse
     */
    displayValue?: string;
    /**
     * 
     * @type {RewardConfigResponse}
     * @memberof LeaderboardPrizeTierResponse
     */
    rewardConfig?: RewardConfigResponse;
    /**
     * All rewards on this tier, populated by the public GET endpoint
     * @type {Array<RewardConfigResponse>}
     * @memberof LeaderboardPrizeTierResponse
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * This tier's computed payout share of the live winner pool. Populated by the detail endpoint for payout-table boards. USD when the pool is USD-mode, FUEL otherwise.
     * @type {number}
     * @memberof LeaderboardPrizeTierResponse
     */
    calculatedAmount?: number;
}

/**
 * Check if a given object implements the LeaderboardPrizeTierResponse interface.
 */
export function instanceOfLeaderboardPrizeTierResponse(value: object): value is LeaderboardPrizeTierResponse {
    if (!('rankStart' in value) || value['rankStart'] === undefined) return false;
    if (!('rankEnd' in value) || value['rankEnd'] === undefined) return false;
    if (!('rewardConfigIds' in value) || value['rewardConfigIds'] === undefined) return false;
    return true;
}

export function LeaderboardPrizeTierResponseFromJSON(json: any): LeaderboardPrizeTierResponse {
    return LeaderboardPrizeTierResponseFromJSONTyped(json, false);
}

export function LeaderboardPrizeTierResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardPrizeTierResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rankStart': json['rankStart'],
        'rankEnd': json['rankEnd'],
        'rewardConfigIds': json['rewardConfigIds'],
        'rewardGrants': json['rewardGrants'] == null ? undefined : ((json['rewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'description': json['description'] == null ? undefined : json['description'],
        'displayValue': json['displayValue'] == null ? undefined : json['displayValue'],
        'rewardConfig': json['rewardConfig'] == null ? undefined : RewardConfigResponseFromJSON(json['rewardConfig']),
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'calculatedAmount': json['calculatedAmount'] == null ? undefined : json['calculatedAmount'],
    };
}

export function LeaderboardPrizeTierResponseToJSON(json: any): LeaderboardPrizeTierResponse {
    return LeaderboardPrizeTierResponseToJSONTyped(json, false);
}

export function LeaderboardPrizeTierResponseToJSONTyped(value?: LeaderboardPrizeTierResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rankStart': value['rankStart'],
        'rankEnd': value['rankEnd'],
        'rewardConfigIds': value['rewardConfigIds'],
        'rewardGrants': value['rewardGrants'] == null ? undefined : ((value['rewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'description': value['description'],
        'displayValue': value['displayValue'],
        'rewardConfig': RewardConfigResponseToJSON(value['rewardConfig']),
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
        'calculatedAmount': value['calculatedAmount'],
    };
}

